import { Button } from "@/components/ui/button";

/**
 * Fallback UI rendered when an uncaught error propagates out of an admin
 * route. Intentionally minimal — admin users benefit from seeing a reload
 * button and a clear statement that the error was captured, without any
 * of the public-facing branding.
 */
export function AdminErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center max-w-md">
        <h1 className="text-2xl font-semibold text-foreground mb-3">
          Something went wrong
        </h1>
        <p className="text-muted-foreground mb-6">
          An unexpected error occurred. The team has been notified. Try
          reloading — if it persists, check the console or Sentry for details.
        </p>
        <Button
          size="lg"
          onClick={() => window.location.reload()}
          className="min-h-[44px]"
        >
          Reload page
        </Button>
      </div>
    </div>
  );
}
